import { APP_NAME } from "@constants/app.constants";
import OrdersEditComponent from "@screens/orders/orders-edit/orders-edit.component";
import OrdersListComponent from "@screens/orders/orders-list/orders-list.component";

const ordersRoutes = [
  {
    name: `Orders - ${APP_NAME}`,
    path: "/orders",
    icon: "layout",
    component: OrdersListComponent,
  },
  {
    name: `Edit Orders - ${APP_NAME}`,
    path: "/orders/edit",    
    component: OrdersEditComponent,
  },
];

export default ordersRoutes;
